// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--33ERL","iframe":"styles-module--iframe--1jVSG"};